import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const authPurcheseBal = createSlice({
  name: "payment",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    ApiSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = null;
    },
  },
});
// const baseUrl = "https://staging.kumeo.com";

export const { requestStart, ApiSuccess, requestFailure } =
  authPurcheseBal.actions;
const PurcheseBal = (payload, navigate) => async (dispatch) => {
  try {
    dispatch(requestStart());

    const GetBalance = await axios.post(`/private/cp`, payload);
    const url = GetBalance?.data;

    // const popup = window.open("", "_blank", "noopener,noreferrer");

    // if (!popup) {
    //   toast.error("Popup blocked! Please allow popups in your browser.");
    //   return;
    // }

    const newTab = window.open("", "_blank");
    if (newTab) {
      // newTab.location.href = `${baseUrl}${url}`;
      newTab.location.href = `${url}`;
    }

    dispatch(ApiSuccess(GetBalance?.data));
  } catch (err) {
    toast.error(err?.response?.data?.message || err.message || " failed!");
    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!")
    );
  }
};

export default authPurcheseBal.reducer;
